import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'
import classNames from 'classnames'

import { TStrapiV4VideoCommonFile } from '../../common-types'
import { DOMAIN } from '@/root/constants'

type TProps = {
  data: TStrapiV4VideoCommonFile
  no_padding?: boolean
  videoWrapperClasss?: string
}

const getYouTubeMetadata = (videoId: string) => {
  return {
    thumbnailUrl: `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`,
    contentUrl: `https://www.youtube.com/watch?v=${videoId}`,
    embedUrl: `https://www.youtube.com/embed/${videoId}`,
  }
}

const StrapiV4Video = (props: TProps) => {
  const { data, no_padding = false, videoWrapperClasss = '' } = props

  if (!data.videoId) return null

  const { thumbnailUrl, contentUrl, embedUrl } = getYouTubeMetadata(
    data.videoId,
  )

  const title =
    "4 CRUCIAL Things to Know About HDFC Bank's HDB Financial Services IPO"
  const description =
    'Another highly awaited IPO is set to hit the market — HDB Financial Services, a subsidiary of HDFC Bank. The total IPO size is ₹12,500 crore, including a ₹2,500 crore fresh issue and a ₹10,000 crore offer for sale. HDB is a diversified non-banking financial company (NBFC) that offers loans to businesses, individuals, and underserved regions across India. With a network of 1,771 branches and 19.2 million customers, it has a strong national presence. Key strengths include backing from HDFC Bank, a AAA credit rating, focus on underbanked segments, and a robust phygital (physical + digital) distribution model.'

  const videoSchema = {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: title,
    description: description,
    thumbnailUrl: thumbnailUrl,
    contentUrl: contentUrl,
    embedUrl: embedUrl,
    uploadDate: '2025-06-23T08:00:00+05:30',
    publisher: {
      '@type': 'Organization',
      name: 'INDmoney',
      url: DOMAIN,
    },
  }

  const addStructuredData = data.videoId === 'R6z42fGuQHc'

  let jsx = <div />

  jsx = (
    <div
      className={classNames('youtube-video-wrapper w-full', {
        'pt-0': no_padding,
        [videoWrapperClasss]: videoWrapperClasss,
      })}
    >
      {/* <YoutubeVideo
        videoId={data.videoId}
        iframeClassName={`rounded-lg w-full ${
          heightClass ? heightClass : 'h-full'
        }`}
        opts={{
          width: conditionalProps.width,
          height: conditionalProps.height,
          playerVars: {
            origin:
              process.env.NODE_ENV === 'development'
                ? 'https://dev.indmoney.com'
                : 'https://www.indmoney.com',
            modestbranding: 1,
            controls: 0,
            rel: 0,
            iv_load_policy: 3,
          },
        }}
      /> */}
      {addStructuredData && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(videoSchema) }}
        />
      )}

      {/* <div className="overflow-hidden rounded-xl" onClick={on_click}> */}
      <div className="overflow-hidden rounded-xl">
        <LiteYouTubeEmbed
          id={data.videoId}
          title={data.title ?? ''}
          params="controls=0"
          webp
          poster="maxresdefault"
        />
      </div>
    </div>
  )

  return jsx
}

export default StrapiV4Video
